export const CO_GET_PACKINGSTANDARD_LISTING = "CO_GET_PACKINGSTANDARD_LISTING"
export const CO_GET_PACKINGSTANDARD_LISTING_SUCCESS = "CO_GET_PACKINGSTANDARD_LISTING_SUCCESS"
export const CO_GET_PACKINGSTANDARD_LISTING_FAILED = "CO_GET_PACKINGSTANDARD_LISTING_FAILED"